export enum ActivityType {
  EMAIL = 'Email',
  CALL = 'Call',
  LINKEDIN = 'Linkedin',
  MEETING = 'Meeting',
  INMAIL = 'InMail',
  LINKEDIN_INVITATION = 'LinkedinInvitation',
  LINKEDIN_VOICE_NOTE = 'LinkedinVoiceNote',
  LINKEDIN_PROFILE_VIEW = 'LinkedinProfileView',
  LINKEDIN_LIKE_LAST_POST = 'LinkedinLikeLastPost',
  GENERIC = 'Generic',
}
